import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Card, CardContent, Divider, Box, IconButton, Stack, TextField } from '@mui/material';

import StandardSelector from '../../../components/standard-selector';
import Iconify from '../../../components/iconify';
import IntegrityBadge from '../../../components/IntegrityBadge';

SessionDetailsCard.propTypes = {
  session: PropTypes.object,
  currentTime: PropTypes.object,
  standards: PropTypes.array,
  addSelectedStandard: PropTypes.func,
  activeStandards: PropTypes.object,
  removeActiveStandard: PropTypes.func,
  createStandard: PropTypes.func,
  closeCreateStandardDialog: PropTypes.func,
  editMode: PropTypes.bool,
  setEditMode: PropTypes.func,
  cancelEditMode: PropTypes.func,
  setDescription: PropTypes.func,
  canEdit: PropTypes.bool,
};

function SessionDetailsCard(props) {
  let formattedCurrentTime;
  if (props.currentTime === undefined) {
    formattedCurrentTime = new Date().toLocaleString();
  } else {
    formattedCurrentTime = props.currentTime.toLocaleString();
  }

  const [activeStandardsState, setActiveStandardsState] = useState(props.activeStandards);

  // update state when props change
  React.useEffect(() => {
    setActiveStandardsState(props.activeStandards);
  }, [props.activeStandards]);

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h4">Data Capture Details</Typography>
          <Stack direction="row" spacing={2} alignItems="left">
            {props.canEdit && (
              !props.editMode ? (
                <IconButton color="primary" onClick={() => {
                  props.setEditMode();
                }}>
                  <Iconify icon="eva:edit-fill" />
                </IconButton>
              ) : (
                <>
                  <IconButton color="error" onClick={() => {
                    props.cancelEditMode();
                  }}>
                    <Iconify icon="eva:close-fill" />
                  </IconButton>
                  <IconButton color="success" onClick={() => {
                    props.setEditMode();
                  }}>
                    <Iconify icon="eva:checkmark-fill" />
                  </IconButton>
                </>
              )
            )}
          </Stack>
        </Box>
        <Divider />
        <br />
        <Typography variant="p" sx={{ mb: 5 }}>
          {props.editMode ? (
            <TextField
              fullWidth
              multiline
              defaultValue={props.session.description}
              placeholder="Enter description"
              onChange={(e) => {
                props.setDescription(e.target.value);
              }}
            />
          ) : (
            props.session.description.length === 0 ? 'No Description' : props.session.description
          )}
        </Typography>
        <br />
        <Divider />
        <br />
        <Typography variant="h6" sx={{ mb: 1 }}>
          Current Time : {formattedCurrentTime}
        </Typography>
        <Divider />
        <br />
        <StandardSelector
          standards={props.standards}
          onSelect={props.addSelectedStandard}
          activeStandards={activeStandardsState}
          addActiveStandard={props.addSelectedStandard}
          removeActiveStandard={props.removeActiveStandard}
          createStandard={props.createStandard}
          closeCreateStandardDialog={props.closeCreateStandardDialog}
        />
      </CardContent>
    </Card>
  );
}

export default SessionDetailsCard;
